<template>
    <li v-if="hasSidebar" class="nav-item">
        
        <a href="javascript:void(0)" class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block">
            &nbsp;
            <!--
            <i class="icon-paragraph-justify3"></i>
            -->
        </a>
    </li>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'sidebar',

    components : {

    },
    watch: {

    },
    data () {
        return {

        }
    },
    computed: {
        ...mapGetters("page" , ['hasSidebar']),
    },
    mounted(){
        this.$nextTick(function () {
            //Application.initSidebars();
        })
    },
    destroyed(){

    },
    methods : {

    }


}
</script>